import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { toast } from 'react-hot-toast';
import ClockLoader from 'shared/components/ClockLoader';
import { apiErrorMessage } from '../utils/responseHelpers';

/**
 * Soft-delete confirmation — marks the record as DELETED (still visible via View all).
 */
const DeleteEntityDialog = ({ open, onClose, onSuccess, config, row, removeItem }) => {
  const [submitting, setSubmitting] = useState(false);

  if (!row) return null;

  const label = config.entityName.toLowerCase();

  const handleConfirm = async () => {
    if (config.readOnlyMutations) {
      toast.error(`${config.entityName} catalog is read-only.`);
      return;
    }
    setSubmitting(true);
    try {
      await removeItem(row);
      toast.success(`${config.entityName} marked as deleted`);
      onSuccess?.();
      onClose();
    } catch (error) {
      toast.error(apiErrorMessage(error, `Failed to delete ${label}.`));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Delete {label}?</DialogTitle>
      <DialogContent>
        <Typography>Do you want to delete the {label}?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirm}
          disabled={submitting || config.readOnlyMutations}
        >
          {submitting ? <ClockLoader inline size={22} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteEntityDialog;
